import { createApp, reactive } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import Confirmation from '@/components/Confirmation.vue';
import ContactButton from '@/components/ContactButton.vue';
import FavoriteEntryButton from '@/components/FavoriteEntryButton.vue';
import FavoritesList from '@/components/FavoritesList.vue';
import FeaturedCarousel from '@/components/FeaturedCarousel.vue';
import File from '@/components/File.vue';
import FilterCheckbox from '@/components/FilterCheckbox.vue';
import Heading from '@/components/Heading.vue';
import ToastProvider from '@/components/providers/ToastProvider.vue';
import * as AccordionComponents from '@/components/ui/accordion';
import { Badge } from '@/components/ui/badge';
import { ButtonGroup } from '@/components/ui/button-group';
import * as CardComponents from '@/components/ui/card';
import * as EmptyComponents from '@/components/ui/empty';
import * as PaginationComponents from '@/components/ui/pagination';
import { Separator } from '@/components/ui/separator';
import VideoEmbed from '@/components/VideoEmbed.vue';
import WorkflowButton from '@/components/WorkflowButton.vue';
import AppLayout from '@/layouts/AppLayout.vue';
import DocumentsLayout from '@/layouts/DocumentsLayout.vue';
import * as FormComponents from '@/lib/form.ts';
import MicroSiteCalculationExample from '@/components/MicroSiteCalculationExample.vue';
import AnimatedLogo from '@/components/AnimatedLogo.vue';
import SlugInput from '@/components/SlugInput.vue';

import '@/styles/app.css';

const app = createApp({
    components: {
        AppLayout,
        Badge,
        ButtonGroup,
        Confirmation,
        ContactButton,
        DocumentsLayout,
        FavoriteEntryButton,
        FavoritesList,
        FeaturedCarousel,
        FilterCheckbox,
        File,
        Heading,
        Separator,
        ToastProvider,
        VideoEmbed,
        WorkflowButton,
        MicroSiteCalculationExample,
        AnimatedLogo,
        SlugInput,
        ...AccordionComponents,
        ...CardComponents,
        ...EmptyComponents,
        ...FormComponents,
        ...PaginationComponents,
    },
});

const context = JSON.parse(
    document.getElementById('app-context')?.textContent ?? '{}'
);
app.provide('context', reactive(context));

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

app.mount('#app');
